module.exports = __webpack_public_path__ + "static/img/h4.4271523.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h4.png
// module id = iKsg
// module chunks = 1